export default __webpack_public_path__ + "static/media/people.edbe51f0.svg";